import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
import ratingQuery from '~/graphql/merchant/rating.gql';
var CONTEXT = 'http://schema.org';
var BRAND = 'Maisons du Monde';
var TYPE = 'Organization';
export default {
  name: 'RatingJsonLd',
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  head: function head() {
    return {
      script: [{
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': CONTEXT,
          '@type': TYPE,
          name: BRAND,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: this.rating.value,
            ratingCount: this.rating.count,
            bestRating: '5.00'
          }
        })
      }]
    };
  },
  apollo: {
    rating: {
      query: ratingQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    }
  },
  render: function render(h) {
    return h(null);
  }
};